import { fromAsync } from "../../async/static/fromAsync.js";
export const eachAsync = (source, action) => {
    async function* generator() {
        for (const value of source) {
            await action(value);
            yield value;
        }
    }
    return fromAsync(generator);
};
